import { Capacitor } from "@capacitor/core";

// Dynamic AdSense loader — WEB ONLY (Google policy forbids AdSense inside native
// apps; the native fallback is AdMob, see lib/admob.js). The publisher ID comes
// from the admin config (settings.adsense.publisher_id), never hardcoded.
// Once "Privacy & messaging" is configured in the AdSense account, this same
// script serves the Google-certified CMP (TCF) consent message in the EEA.
let loadedFor = null;

export function ensureAdSenseLoaded(publisherId) {
  const id = (publisherId || "").trim();
  if (!id || Capacitor.isNativePlatform()) return false;
  if (loadedFor) return true;
  if (document.querySelector("script[data-yalola-adsense]")) { loadedFor = id; return true; }
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(id)}`;
  s.setAttribute("data-yalola-adsense", "1");
  document.head.appendChild(s);
  loadedFor = id;
  return true;
}
